import { Button, Col, Form, Input, message, Popconfirm, Row, Space, Spin, Table, Tooltip } from "antd";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ModalNovoBloqueio from "./ModalNovoBloqueio";
import { bloqueioService } from "../../services/Bloqueio-Service/bloqueio-service";
import { ColumnsType } from "antd/lib/table";
import moment from "moment";
import ModalEditarBloqueio from "./ModalEditarBloqueio";
import { toISOFormat } from "../../utils/date";


interface BloqueioProps {
    permissao?: any
}


const Bloqueio:React.FC<BloqueioProps> = (prop) =>{

    const [form] = Form.useForm();
    const [visibleModal, setVisibleModal] = useState(false);
    const [visibleEditarModal, setVisibleEditarModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [infoModalEditar, setInfoModalEditar] = useState({})
    const [bloqueios, setBloqueios] = useState();

    useEffect(()=>{
        getBloqueios()
    },[])

    const getBloqueios = async () => {
        const resp = await bloqueioService.get();
        const formattedData = resp.data.map((item:any)  => ({
            ...item,
            dataBloqueio: moment(item.dataBloqueio).format('DD/MM/YYYY')
        }));
        setBloqueios(formattedData)
    }

    const ativarDesativarBloqueio = (bloqueio: any, ehAtivo: boolean) => {
        bloqueio.dataBloqueio = toISOFormat(bloqueio.dataBloqueio)
        bloqueioService.put({
            BloqueioID: bloqueio.bloqueioID,
            Nome: bloqueio.nome,
            Descricao: bloqueio.descricao,
            DataBloqueio: bloqueio.dataBloqueio,
            Periodo: bloqueio.periodo,
            MunicipioID: bloqueio.municipioID,
            Ativo: ehAtivo
        }).then(response => {
            if (response.data.valido) {
                message.success('Bloqueio alterado com sucesso!');
            }
            else {
                message.error(response.data.error,10)               
            }            
        }).catch(() => {
            message.error('Falha na requisição');
        }).finally(() => {
            getBloqueios();
        })
    }

    const handleCloseNovoBloqueio = () => {
        getBloqueios();
    };

    const handleCloseEditarBloqueio = () => {
        getBloqueios();
    };

    const columns: ColumnsType<any> = [
        {
            title: 'Nome',
            dataIndex: 'nome',
        },
        {
            title: 'Data do Bloqueio',
            dataIndex: 'dataBloqueio',
        },
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            ellipsis: {
                showTitle: false,
            },
            render: descricao => (
                <Tooltip placement="topLeft" title={descricao}>
                    {descricao}
                </Tooltip>
            ),
        },
        {
            title: 'Período',
            dataIndex: 'periodo',
        },
        {
            title: 'Município',
            render: item => (
                <>
                    {item.municipio.nome}
                </>
            ),
        },
        {
        title: 'Ações',
            key: 'action',
            render: (text, record: any) => {
                return (
                <Space size="middle">
                    <Button htmlType="button" onClick={() => { setVisibleEditarModal(true); setInfoModalEditar(record)}}>Editar</Button>
                    {
                        record.ativo?
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.bloqueioID} placement="top" title="Você tem certeza que deseja desativar esse bloqueio?" onConfirm={() => { ativarDesativarBloqueio(record, false); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.bloqueio} danger >  Desativar </Button>
                                </Popconfirm>
                                : null
                            :
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.feriadoID} placement="top" title="Você tem certeza que deseja ativar esse bloqueio?" onConfirm={() => { ativarDesativarBloqueio(record, true); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.feriadoID}  >  Ativar </Button>
                                </Popconfirm>
                                : null
                    }
                </Space>
            )}
        }
    ]
    
    return(
        <>
            <Header></Header>
            <br/>
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={loading}>
                        <Form
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                        layout="horizontal"
                        size="middle"
                        form={form}
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Nome"
                                        name="nome"
                                    >
                                        <Input placeholder="Informe o nome do Bloqueio" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Descrição"
                                        name="descricao"
                                    >
                                        <Input placeholder="Informe a descrição do Bloqueio" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={() => setVisibleModal(true)} type="ghost" htmlType="button">
                                        Novo Bloqueio
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>

                            
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                        <Col className="gutter-row" span={24}>
                            <Table dataSource={bloqueios} loading={loading} columns={columns} rowKey={"bloqueioID"} bordered={true}></Table>
                        </Col>
                </Row>
            </div>
            <ModalNovoBloqueio visible={visibleModal} setVisible={setVisibleModal} onClose={handleCloseNovoBloqueio}/>
            <ModalEditarBloqueio visible={visibleEditarModal} setVisible={setVisibleEditarModal}  info={infoModalEditar} onClose={handleCloseEditarBloqueio} />
            <Footer></Footer>
        </>
    )
}

const mapStateToProps = (state: any) => ({
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Bloqueio);